import { render, staticRenderFns } from "./Form.Upload.vue?vue&type=template&id=0c6782e1&scoped=true"
import script from "./Form.Upload.vue?vue&type=script&lang=js"
export * from "./Form.Upload.vue?vue&type=script&lang=js"
import style0 from "./Form.Upload.vue?vue&type=style&index=0&id=0c6782e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6782e1",
  null
  
)

export default component.exports